import React, {Component} from 'react';

class FinctionalSkillsLoad extends Component{
    render(){
        return(<div className="tw-h-52 tw-container tw-text-center tw-mt-5 tw-mb-5">
                <h1 className="tw-text-gray-400 tw-text-4xl tw-mt-28">Loading <i className="fa fa-spinner fa-spin"></i></h1>
            </div>)
    }
}

export default FinctionalSkillsLoad


// WEBPACK FOOTER //
// ./src/components/containers/functional-skills-swimlane/functional-skills-load.js